import {
  fetchComissionedPayrollListSettings,
  fetchComissionedListFull
} from './services';

import {
  setIsLoading,
  setComissionedPayrollList,
  clearComissionedPayrollList
} from './actions';

export const loadComissionedPayrollListSettings = ({ userId, establishmentId, page, limit, qp, isSetList = true }) => dispatch => {
  dispatch(setIsLoading(true));

  return fetchComissionedPayrollListSettings(userId, establishmentId, page, limit, qp)
    .then(({ data }) => {
      if(isSetList) {
        dispatch(setComissionedPayrollList(data));
      }

      return Promise.resolve(data);
    })
    .catch(() => {
      dispatch(clearComissionedPayrollList());
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadComissionedListFull = (userId, establishmentId) => dispatch => {
  return fetchComissionedListFull(userId, establishmentId)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject([]);
    })
}